var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var __generator = (this && this.__generator) || function (thisArg, body) {
    var _ = { label: 0, sent: function() { if (t[0] & 1) throw t[1]; return t[1]; }, trys: [], ops: [] }, f, y, t, g;
    return g = { next: verb(0), "throw": verb(1), "return": verb(2) }, typeof Symbol === "function" && (g[Symbol.iterator] = function() { return this; }), g;
    function verb(n) { return function (v) { return step([n, v]); }; }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while (_) try {
            if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [op[0] & 2, t.value];
            switch (op[0]) {
                case 0: case 1: t = op; break;
                case 4: _.label++; return { value: op[1], done: false };
                case 5: _.label++; y = op[1]; op = [0]; continue;
                case 7: op = _.ops.pop(); _.trys.pop(); continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) { _ = 0; continue; }
                    if (op[0] === 3 && (!t || (op[1] > t[0] && op[1] < t[3]))) { _.label = op[1]; break; }
                    if (op[0] === 6 && _.label < t[1]) { _.label = t[1]; t = op; break; }
                    if (t && _.label < t[2]) { _.label = t[2]; _.ops.push(op); break; }
                    if (t[2]) _.ops.pop();
                    _.trys.pop(); continue;
            }
            op = body.call(thisArg, _);
        } catch (e) { op = [6, e]; y = 0; } finally { f = t = 0; }
        if (op[0] & 5) throw op[1]; return { value: op[0] ? op[1] : void 0, done: true };
    }
};
var __read = (this && this.__read) || function (o, n) {
    var m = typeof Symbol === "function" && o[Symbol.iterator];
    if (!m) return o;
    var i = m.call(o), r, ar = [], e;
    try {
        while ((n === void 0 || n-- > 0) && !(r = i.next()).done) ar.push(r.value);
    }
    catch (error) { e = { error: error }; }
    finally {
        try {
            if (r && !r.done && (m = i["return"])) m.call(i);
        }
        finally { if (e) throw e.error; }
    }
    return ar;
};
var __spreadArray = (this && this.__spreadArray) || function (to, from, pack) {
    if (pack || arguments.length === 2) for (var i = 0, l = from.length, ar; i < l; i++) {
        if (ar || !(i in from)) {
            if (!ar) ar = Array.prototype.slice.call(from, 0, i);
            ar[i] = from[i];
        }
    }
    return to.concat(ar || Array.prototype.slice.call(from));
};
// Libraries
import React, { useMemo } from 'react';
import { useNavigate } from 'react-router-dom';
import { useDropzone } from 'react-dropzone';
// Components
import FSButton from '@components/FSButton';
import { uploadAndImportFile } from './importActions';
import SelectInput from '@shared/input/SelectInput';
// Icons
import { RiUploadCloud2Line } from 'react-icons/ri';
// Hooks
import { useLanguage } from '@base/LanguageProvider';
import { useDetectDimensions, useImportJobs } from '@data/importJob/importJobActions';
import { useImportJobRouteParams } from '@data/hooks/importJobsRouteParams';
import useTheme from '@styled/useTheme';
export default function ImportJobNew() {
    var _this = this;
    var _a;
    var L = useLanguage().L;
    var theme = useTheme();
    var navigate = useNavigate();
    var importJobRouteParams = useImportJobRouteParams();
    var importJobs = (_a = useImportJobs().data) !== null && _a !== void 0 ? _a : [];
    var detectDimensions = useDetectDimensions();
    var onDrop = React.useCallback(function (acceptedFiles) { return __awaiter(_this, void 0, void 0, function () {
        var createdJobs, createdJobId;
        return __generator(this, function (_a) {
            switch (_a.label) {
                case 0: return [4 /*yield*/, uploadAndImportFile(acceptedFiles[0], importJobRouteParams.replaceImportJobId, L)];
                case 1:
                    createdJobs = _a.sent();
                    if (!(createdJobs !== undefined && createdJobs.length === 1)) return [3 /*break*/, 3];
                    createdJobId = createdJobs[0].id;
                    navigate("/import/job/".concat(createdJobId));
                    return [4 /*yield*/, detectDimensions.mutateAsync(createdJobId)];
                case 2:
                    _a.sent();
                    return [3 /*break*/, 4];
                case 3:
                    if (createdJobs !== undefined && createdJobs.length > 0) {
                        navigate('/import/previous');
                    }
                    _a.label = 4;
                case 4: return [2 /*return*/];
            }
        });
    }); }, [importJobRouteParams.replaceImportJobId]);
    var handleBrowseClick = function () {
        var _a;
        (_a = inputRef.current) === null || _a === void 0 ? void 0 : _a.click();
    };
    var _b = useDropzone({
        onDrop: onDrop,
        noClick: true,
    }), getRootProps = _b.getRootProps, getInputProps = _b.getInputProps, isDragAccept = _b.isDragAccept, inputRef = _b.inputRef;
    var dropzoneStyle = useMemo(function () {
        if (isDragAccept) {
            return { backgroundColor: theme.colors.neutral.w100 };
        }
        else {
            return {};
        }
    }, [isDragAccept]);
    var previousJobsOptions = __spreadArray([
        {
            label: 'None',
            value: null,
        }
    ], __read(importJobs.map(function (job) { return ({
        label: job.title,
        value: job.id,
    }); })), false);
    return (React.createElement("div", { className: "fs-import-container" },
        importJobs.length > 0 && (React.createElement("div", { className: "import-header" },
            React.createElement("div", { style: { minWidth: 250 } },
                React.createElement(SelectInput, { name: "selectJob", options: previousJobsOptions, placeholder: L('Choose job to replace'), value: importJobRouteParams.replaceImportJobId, onChange: function (e) { return __awaiter(_this, void 0, void 0, function () {
                        var selectedId;
                        return __generator(this, function (_a) {
                            selectedId = typeof e.target.value === 'number' ? e.target.value : null;
                            if (selectedId === null) {
                                navigate('/import');
                            }
                            else {
                                navigate("/import/replace/".concat(selectedId));
                            }
                            return [2 /*return*/];
                        });
                    }); } })),
            React.createElement(FSButton, { "$type": "secondary", className: "right", title: L('Previous Imports'), onClick: function () {
                    navigate('/import/previous');
                } }))),
        React.createElement("div", { className: "import-new" },
            importJobs.length === 0 && (React.createElement("div", { className: "import-new-intro" },
                React.createElement("h2", null, L('Welcome to Import.')),
                React.createElement("p", null, L('Import your spreadsheets from Excel right into Farseer and manage them.')))),
            React.createElement("div", __assign({ className: "import-new-dropfield" }, getRootProps({ style: dropzoneStyle })),
                React.createElement("input", __assign({ type: "file", ref: inputRef, style: { display: 'none' } }, getInputProps())),
                React.createElement(RiUploadCloud2Line, null),
                React.createElement("p", null, L('Drag your file here'))),
            React.createElement("div", { className: "import-new-browse" },
                React.createElement("span", { className: "import-new-or" },
                    React.createElement("span", { className: "line" }),
                    L('OR'),
                    React.createElement("span", { className: "line" })),
                React.createElement(FSButton, { title: L('Browse'), onClick: handleBrowseClick })))));
}
